import {
  MobileDateTimePickerProps,
  MobileDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

function DateTimeInput(props: MobileDateTimePickerProps<Dayjs>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDateTimePicker format="DD/MM/YYYY HH:mm" {...props} />
    </LocalizationProvider>
  );
}

export default DateTimeInput;
